import { DerivativeWallet } from "./derivative_wallet";
import { TYPE_NAME_ETC } from "@helpers/constants";

export class EtcWallet extends DerivativeWallet {
	public static TypeName: string = TYPE_NAME_ETC;
}
